(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-featured-category"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.cat-tab-item-slider').slick({
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 5,
      variableWidth: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 8000,
      arrows: false,
      responsive: [
        {
          breakpoint: 699,
          settings: {
            arrows: true,       // Enable arrows below 798px
            slidesToShow: 2,    // Show 2 slides
            variableWidth: true,  // Variable width can conflict, better to disable it for smaller screens
            dots: false,        // Disable dots for smaller screens
            slidesToScroll: 1,
            infinite: true,
            autoplay: false,
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-26-6"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-list-wrapper',
      pagination: '#magepow-Pagination'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-b"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-list-wrapper',
      pagination: '#magepow-Pagination'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-card"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-list-wrapper',
      pagination: '#magepow-Pagination'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-loafers"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-list-wrapper',
      pagination: '#magepow-Pagination'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-list-wrapper',
      pagination: '#magepow-Pagination'
    });
  });

  } catch(e) { console.error(e); }
})();
})();
